import { z } from "zod";
import { WorkspaceRole, Theme, ProfileSetupStep } from './enums';

export const User = z.object({
  theme: Theme.nullable(),
  profileSetupStep: ProfileSetupStep,
  id: z.string(),
  name: z.string(),
  image: z.string().nullable(),
  email: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  lastSeen: z.coerce.date().nullish(),
  emailVerified: z.coerce.date().nullable(),
  isAdmin: z.boolean(),
  hasViewedWorkspaceOnboarding: z.boolean(),
  hasViewedEditorOnboarding: z.boolean(),
  hasPassword: z.boolean().nullish(),
  workspaces: z.array(z.object({ id: z.string(), role: WorkspaceRole })).optional(),
  onboardingDetails: z.any().nullish(),
})
export type User = z.infer<typeof User>;

export const ResetPasswordRequest = z.object({
  id: z.string(),
  userId: z.string(),
})
export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequest>;